module.exports = __webpack_public_path__ + "static/digital929ef306b207e27f759d26927ade0dc90.png";